module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sale_common"
  }, [_c('div', {
    staticClass: "sale_common_main"
  }, [_c('div', {
    staticClass: "sale_common_title"
  }, [_c('h3', [_c('p'), _vm._v("常见问题\n      ")]), _vm._v(" "), _c('p', [_vm._v("***************************************************************************************************************************************************************************************************************************************************************")])]), _vm._v(" "), _c('div', {
    staticClass: "sale_common_problem"
  }, [_c('div', {
    staticClass: "answer_person"
  }, [_c('div', {
    staticClass: "answer_con"
  }, [_c('div', {
    staticClass: "answer_question"
  }, [_c('p', [_vm._v("马桶购买需要注意什么？")])]), _vm._v(" "), _c('div', {
    staticClass: "ans_content"
  }, [_c('p', [_c('i', [_vm._v("精华")]), _vm._v("1.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出水马桶。\n            ")]), _vm._v(" "), _c('p', [_vm._v("2.注意挑选瓷质，瓷质细腻，釉面光洁致密的马桶，水和污垢不易渗入，容易冲净，既美观又 便于清洁。")]), _vm._v(" "), _c('p', [_vm._v("3.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出")])]), _vm._v(" "), _c('div', {
    staticClass: "ans_praise"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/bicon04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("回答")]), _vm._v("10\n            ")]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/bicon08.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("取消收藏")]), _vm._v("10\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "answer_con"
  }, [_c('div', {
    staticClass: "answer_question"
  }, [_c('p', [_vm._v("马桶购买需要注意什么？")])]), _vm._v(" "), _c('div', {
    staticClass: "ans_content"
  }, [_c('p', [_c('i', [_vm._v("精华")]), _vm._v("1.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出水马桶。\n            ")]), _vm._v(" "), _c('p', [_vm._v("2.注意挑选瓷质，瓷质细腻，釉面光洁致密的马桶，水和污垢不易渗入，容易冲净，既美观又 便于清洁。")]), _vm._v(" "), _c('p', [_vm._v("3.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出")])]), _vm._v(" "), _c('div', {
    staticClass: "ans_praise"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/bicon04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("回答")]), _vm._v("10\n            ")]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/bicon08.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("收藏")]), _vm._v("10\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "answer_con"
  }, [_c('div', {
    staticClass: "answer_question"
  }, [_c('p', [_vm._v("马桶购买需要注意什么？")])]), _vm._v(" "), _c('div', {
    staticClass: "ans_content"
  }, [_c('p', [_c('i', [_vm._v("精华")]), _vm._v("1.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出水马桶。\n            ")]), _vm._v(" "), _c('p', [_vm._v("2.注意挑选瓷质，瓷质细腻，釉面光洁致密的马桶，水和污垢不易渗入，容易冲净，既美观又 便于清洁。")]), _vm._v(" "), _c('p', [_vm._v("3.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出")])]), _vm._v(" "), _c('div', {
    staticClass: "ans_praise"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/bicon04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("回答")]), _vm._v("10\n            ")]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/bicon08.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("取消收藏")]), _vm._v("10\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "answer_con"
  }, [_c('div', {
    staticClass: "answer_question"
  }, [_c('p', [_vm._v("马桶购买需要注意什么？")])]), _vm._v(" "), _c('div', {
    staticClass: "ans_content"
  }, [_c('p', [_c('i', [_vm._v("精华")]), _vm._v("1.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出水马桶。\n            ")]), _vm._v(" "), _c('p', [_vm._v("2.注意挑选瓷质，瓷质细腻，釉面光洁致密的马桶，水和污垢不易渗入，容易冲净，既美观又 便于清洁。")]), _vm._v(" "), _c('p', [_vm._v("3.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出")])]), _vm._v(" "), _c('div', {
    staticClass: "ans_praise"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/bicon04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("回答")]), _vm._v("10\n            ")]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/bicon08.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("取消收藏")]), _vm._v("10\n            ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e444194!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/saleCommonProblem.vue
// module id = 1696
// module chunks = 3